import React, { useState, useEffect } from 'react';

import { makeStyles } from '@mui/styles';

import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';


const useStyles = makeStyles(theme => ({   
    
    searchBoxOuterRow: {
          display: 'flex', 
        flexDirection: 'row',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',
        
    },

    searchBoxDiv: {
      
        //backgroundColor: 'lightgray', //#F3F3F3',
    },
   
    customerSearchRow: {
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'flex-start',
        alignItems: 'flex-start',  
        flexWrap: 'wrap',
        marginLeft: '0.2em',
        // flexBasis: '100%',
        // height: '0',
    
       },
      
      
      
   

    }));

    


const CustomerSearchMini = (props) => {
    const classes = useStyles();
    var store = require('store')

      
    const [searchObject, setSearchObject] = useState({});
   
 
    const clearSearch = () => {
        var clearedSearchObject = {...searchObject};

        for (const [key, value] of Object.entries(clearedSearchObject)) {
            clearedSearchObject[key] = '';            
        }
        
        setSearchObject(clearedSearchObject);
    }

       
    useEffect(() =>  { 
        if (props.onIdSearchObjectChange)
            props.onIdSearchObjectChange(searchObject);  //post searchObject to parent component whenever it changes
        
      },[searchObject])

      useEffect(() =>  { 
        clearSearch();
        
      },[props.doRefresh])
  


    return(        
        
    <div className={classes.searchBoxOuterRow}>

    <div className={classes.searchBoxDiv}>
        <div className={classes.customerSearchRow}>
            <TextField InputLabelProps={{shrink: true}} style={{width: '134px', marginLeft: '0.3em', marginTop: '0.3em', marginBottom: '.2em'}} 
            value={searchObject.customerNo} className={classes.textField} onFocus={clearSearch} 
            onChange={e => setSearchObject({...searchObject, customerNo: e.target.value })}    
            onKeyPress={(ev)=>{if (ev.key==='Enter') props.searchForCustomers();}}
            variant="outlined" label="Kundenr" size='small'></TextField>
            
            <TextField InputLabelProps={{shrink: true}} style={{width: '136px', marginLeft: '0.3em', marginTop: '0.3em'}} 
            value={searchObject.apiId} className={classes.textField} onFocus={clearSearch} 
            onChange={e => setSearchObject({...searchObject, apiId: e.target.value })} //ApiId
            onKeyPress={(ev)=>{if (ev.key==='Enter') props.searchForCustomers();}}
            variant="outlined" label="API Id" size='small'></TextField>
            
            <TextField InputLabelProps={{shrink: true}} style={{width: '134px', marginLeft: '0.3em', marginTop: '0.3em'}} 
            value={searchObject.invoiceNo} className={classes.textField} onFocus={clearSearch} 
            onChange={e => setSearchObject({...searchObject, invoiceNo: e.target.value })} 
            onKeyPress={(ev)=>{if (ev.key==='Enter') props.searchForCustomers();}}
            variant="outlined" label="Fakturanr" size='small'></TextField>                                
                    
        
        </div>
    

    </div>

    
    </div>
    )
    
};

export default CustomerSearchMini;